"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function obfuscate(value) {
    try {
        return window.btoa(value);
    }
    catch (ex) {
        console.error(ex);
        return value;
    }
}
exports.obfuscate = obfuscate;
function deObfuscate(value) {
    try {
        return window.atob(value);
    }
    catch (ex) {
        console.error(ex);
        return value;
    }
}
exports.deObfuscate = deObfuscate;
function isObfuscated(value) {
    try {
        return window.btoa(window.atob(value)) === value;
    }
    catch (ex) {
        // window.atob(value) throws a DOMException if value is not valid base64, so we can return false here
        return false;
    }
}
exports.isObfuscated = isObfuscated;
//# sourceMappingURL=obfuscation.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/utils/obfuscation.js
// module id = 737
// module chunks = 1